const translations = {
  'faqs.seo.title':
    'Preguntas frecuentes de TEFL: desde los salarios de los maestros hasta los requisitos de ingreso',
  'faqs.seo.description': `Lee las preguntas frecuentes de TEFL Iberia para obtener más información sobre la enseñanza de TEFL, desde los salarios de los docentes hasta los requisitos de ingreso.`,
  'faqs.sec1.title': 'Preguntas frecuentes',
  'faqs.sec1.description':
    '¿Quieres entender más? Aquí tienes algunas respuestas a nuestras preguntas más comunes.',

  'faqs.sec1.button1': 'Cursos de TEFL',
  'faqs.sec1.button2': 'Visa de Estudiantes',
  'faqs.sec1.button3': 'Alojamiento',
  'faqs.sec1.button4': 'Trabajar en España ',
};

export default translations;
